import React, { useState } from 'react';
import { Modal, Radio, Button, Space, Form } from 'antd';
import CreateIcon from '../../../../../assets/Images/icons/create-rr-img.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import RiskRegisterService from '../../../../../services/RiskRegister.service';
import useNotify from '../../../../../context/Notification/useNotify';
import { STATUS_ID } from '../../../../risk-register/STATUS_ID';
import { ROUTER } from '../../../../../constants/router';

export default function ModalRisk({ open, handelClose, detailInfo }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const Navigate = useNavigate();
    const [value, setValue] = useState(1);
    let { activityId } = useParams();
    const [form] = Form.useForm();
    const notify = useNotify();

    const onChange = (e) => {
        setValue(e.target.value);
    };

    const onSubmit = async () => {
        setLoading(true);
        // เชื่อมต่อกับทะเบียนความเสี่ยงเดิม // สร้างใหม่แบบคัดลอกจากทะเบียนความเสี่ยงเดิม
        if (value === 1 || value === 3) {
            getRegistered(value);
        }
        // สร้างใหม่
        if (value === 2) {
            try {
                const { data } =
                    await RiskRegisterService.createRiskRegisterInitial({
                        riskAssessmentId: detailInfo?.riskAssessmentId,
                    });
                if (data.resultCode === 1) {
                    // สร้างใหม่
                    if (value === 2) {
                        Navigate(
                            `${ROUTER.RISK_MANAGEMENT.RR}/${data?.resultData?.riskRegisterId}`,
                            { state: { mode: 'create' } }
                        );
                    }
                    setLoading(false);
                    handelClose();
                } else {
                    setLoading(false);
                    handelClose();
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: data?.errorData?.msg,
                    });
                }
            } catch (error) {
                setLoading(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: error,
                });
            }
        }
    };
    const getRegistered = async (value) => {
        let ids =
            value === 1
                ? [STATUS_ID.REVISE, STATUS_ID.DRAFT]
                : [
                      STATUS_ID.REVISE,
                      STATUS_ID.DRAFT,
                      STATUS_ID.REVIEWED,
                      STATUS_ID.WAITING_FOR_REVIEW,
                  ];

        try {
            let payload = {
                statusIds: ids.join(','),
                departmentId: 'owner',
                p: 1,
                ps: 10,
                s: 'modify_date',
                sd: 'DESC',
            };
            const { data } = await RiskRegisterService.searchRiskRegisterTab2(
                payload
            );
            const resultData = data?.resultData;
            // console.log(resultData)
            setLoading(false);
            if (resultData?.result?.length > 0) {
                if (value === 1) {
                    Navigate(`${ROUTER.RISK_MANAGEMENT.RR}/connect`, {
                        state: { mode: 'connect', activityId: activityId },
                    });
                }
                if (value === 3) {
                    Navigate(`${ROUTER.RISK_MANAGEMENT.RR}/cloning`, {
                        state: { mode: 'clone' },
                    });
                }
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('RoPA.NoRiskRegisterCanBeConnected'),
                    timeOut: 120000,
                    closeable: true,
                });
                handelClose();
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
                setValue(1);
                form.resetFields();
            }}
        >
            <>
                <div className="flex flex-col space-y-4 justify-center items-center py-4 text-center">
                    <div>
                        <img src={CreateIcon} alt="Create Risk Register" />
                    </div>
                    <div className="text-[22px]">
                        {t('RR.CreateNewRiskRegister')}
                    </div>
                </div>

                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    onFinish={onSubmit}
                    initialValues={{ createInitail: 1 }}
                >
                    <div className="flex flex-col space-y-4 justify-center items-center py-2 text-left">
                        <Form.Item name="createInitail">
                            <Radio.Group onChange={onChange} value={value}>
                                <Space direction="vertical">
                                    <Radio
                                        className={
                                            value === 1
                                                ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                        }
                                        key={1}
                                        value={1}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {t('RR.ConnectRiskRegister')}
                                    </Radio>
                                    <Radio
                                        className={
                                            value === 2
                                                ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                        }
                                        key={2}
                                        value={2}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {t('RR.CreateNew')}
                                    </Radio>
                                    <Radio
                                        className={
                                            value === 3
                                                ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-80`
                                                : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-80`
                                        }
                                        key={3}
                                        value={3}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {t('RR.CreateAndCloningRiskRegister')}
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    <div className="flex justify-center items-center py-4 space-x-4">
                        <Button
                            type="primary"
                            onClick={() => {
                                handelClose();
                                setValue(1);
                                form.resetFields();
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={() => onSubmit()}
                            size="large"
                            type="primary"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </>
        </Modal>
    );
}
